import { Component, h, Host } from "@stencil/core";

@Component({
    tag: "ux-sidebar-footer",
    styleUrl: "sidebar-footer.scss",
    shadow: false
})
export class SidebarFooter {
    render() {
        return (
            <Host class="ux-sidebar-footer">
                <slot />
            </Host>
        );
    }
}
